import { Heart } from 'lucide-react';

export const LikeButton = ({ liked, count, onToggle, onShowLikers, testId }) => (
  <div className="flex items-center gap-1">
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onToggle(); }}
      aria-pressed={liked}
      aria-label={liked ? 'إلغاء الإعجاب' : 'إعجاب'}
      className="p-1 rounded-full hover:bg-rose-50 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-300"
      data-testid={`${testId}-btn`}
    >
      <Heart className={`w-4 h-4 transition-[transform,color] duration-200 ${liked ? 'fill-rose-500 text-rose-500 animate-heart-pop' : 'text-muted-foreground'}`} />
    </button>
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onShowLikers?.(); }}
      className="text-xs tabular-nums text-muted-foreground hover:text-rose-600 transition-colors duration-150 min-w-[1ch]"
      data-testid={`${testId}-count`}
    >
      {count}
    </button>
  </div>
);
